export function getCricketSilhouette(role?: string) {
  switch (role) {
    case "bowler":
      return "/images/cricket-bowler-silhouette.hero.webp";
    case "wicketkeeper":
      return "/images/cricket-keeper-silhouette.hero.webp";
    case "batter":
    case "allRounder":
    case "allrounder":
    default:
      return "/images/cricket-batter-silhouette.hero.webp";
  }
}

